import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Button,
  IconButton,
  TextField,
  LinearProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import { CheckBoxOutlineBlank, CheckBox } from "@material-ui/icons";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";
import serviciosTablero from "utils/serviciosTablero";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  gridTareas: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "gray",
      borderRadius: "4px",
    },
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

const CheckListProgressBar = ({
  tasks = [],
  lista,
  setListasTarjeta,
  tarjeta,
  updateData,
  setCargando,
  setMensaje,
  idjerarquia,
  usuario,
  permisos,
}) => {
  const classesTablero = useStylesTablero();
  const classes = useStyles();
  const [currentTasks, setCurrentTasks] = useState(tasks);
  const [openDialog, setOpenDialog] = useState(false);
  const [taskTitle, setTaskTitle] = useState("");
  const [editingTask, setEditingTask] = useState(null);
  const [editingChecklist, setEditingChecklist] = useState(null); // Guarda el checklist que se está editando.
  const [checklistTitle, setChecklistTitle] = useState("");
  const [openDialogDelete, setOpenDialogDelete] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const completedTasks = currentTasks.filter((task) => task.completed).length;
  const totalTasks = currentTasks.length;
  const progress = totalTasks > 0 ? (completedTasks / totalTasks) * 100 : 0;

  const handleOpenDialog = () => {
    setOpenDialog(true);
    setTaskTitle("");
    setEditingTask(null);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setTaskTitle("");
    setEditingTask(null);
  };

  //Dialog para Lista de tareas
  const handleClickOpen = (index) => {
    setSelectedIndex(index);
    setOpenDialogDelete(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDialogDelete(false);
  };
  const handleConfirmDeleteTareas = () => {
    if (selectedIndex !== null) {
      handleDeleteTask(selectedIndex);
      handleCloseDeleteDialog();
    }
  };

  const getTareas = async () => {
    serviciosTablero.getTareas(
      (status, mensaje, data) => {
        const updatedTasks = data?.map((task) => ({
          ...task,
          completed: task.idestatus === 2, // Si el estado es 2, marcar como completada
        }));
        
        setCurrentTasks(updatedTasks || []);
      },
      setCargando,
      { idlista: lista }
    );
  };

  useEffect(() => {
    getTareas();
  }, []);

  const handleAddOrEditTask = () => {
    if (!taskTitle.trim()) return;

    const taskData = {
      titulo: taskTitle,
      idlista: lista,
    };

    if (editingTask) {
      // Editar tarea
      serviciosTablero.editTarea(
        (status, mensaje, data) => {
          if (status === 1) {
            setCurrentTasks((prev) =>
              prev.map((task) =>
                task.iditem === editingTask.iditem
                  ? { ...task, titulo: taskTitle }
                  : task
              )
            );
            handleCloseDialog();
            setMensaje({ open: true, status: status, value: mensaje });
          } else {
            setMensaje({
              open: true,
              status: -1,
              value: "Error al editar tarea.",
            });
          }
        },
        setCargando,
        { ...taskData, idtarea: editingTask.iditem }
      );
    } else {
      // Añadir nueva tarea
      serviciosTablero.addTarea(
        (status, mensaje, data) => {
          if (status === 1) {
            setCurrentTasks((prev) => [
              ...prev,
              { ...data.tarea, completed: false },
            ]);
            handleCloseDialog();
            setMensaje({ open: true, status: status, value: mensaje });
            setListasTarjeta(data.progreso);
            let nuevaDataTarjeta = { ...tarjeta, progreso: data.progreso };
            updateData("tarjeta", nuevaDataTarjeta, tarjeta.idtarjeta);
          } else {
            setMensaje({
              open: true,
              status: -1,
              value: "Error al crear tarea.",
            });
          }
        },
        setCargando,
        taskData
      );
    }
  };

  const handleDeleteTask = (taskId) => {
    serviciosTablero.deleteTarea(
      (status, mensaje, data) => {
        if (status === 1) {
          setCurrentTasks((prev) =>
            prev.filter((task) => task.iditem !== taskId)
          );
          setMensaje({ open: true, status: status, value: mensaje });
          setListasTarjeta(data.progreso);
          let nuevaDataTarjeta = { ...tarjeta, progreso: data.progreso };
          updateData("tarjeta", nuevaDataTarjeta, tarjeta.idtarjeta);
        } else {
          setMensaje({
            open: true,
            status: -1,
            value: "Error al eliminar la tarea.",
          });
        }
      },
      setCargando,
      { iditem: taskId }
    );
  };

  const handleToggleTaskCompletion = (taskId) => {
    const updatedTasks = currentTasks.map((task) => {
      if (task.iditem === taskId) {
        const newStatus = task.completed ? 1 : 2;
        return { ...task, completed: !task.completed, idestatus: newStatus };
      }
      return task;
    });

    setCurrentTasks(updatedTasks);

    serviciosTablero.updateTareaStatus(
      (status, mensaje, data) => {
        setMensaje({ open: true, status: status, value: mensaje });
        if (status == 1) {
          setListasTarjeta(data?.progreso);
          let nuevaDataTarjeta = { ...tarjeta, progreso: data?.progreso };
          updateData("tarjeta", nuevaDataTarjeta, tarjeta?.idtarjeta);
        }
      },
      setCargando,
      {
        iditem: taskId,
        estatus: updatedTasks?.find((task) => task.iditem === taskId).idestatus,
      }
    );
  };
  return (
    <div style={{ marginBottom: "16px" }}>
      <Typography variant="subtitle1" gutterBottom>
        Progreso del checklist:
      </Typography>
      <LinearProgress
        variant="determinate"
        value={progress}
        className={classesTablero.progressBar}
      />
      <Typography variant="body2" color="#CCCCCC">
        {completedTasks} de {totalTasks} tareas completadas
      </Typography>

      <Grid container spacing={0} style={{ marginTop: "10px" }}>
        {currentTasks?.map((task) => (
          <>
            <Grid
              item
              xs={9}
              key={task.iditem}
              className={classes.gridTareas}
              onClick={() => handleToggleTaskCompletion(task.iditem)}
            >
              {task.completed ? <CheckBox /> : <CheckBoxOutlineBlank />}
              <Typography
                variant="body1"
                style={{
                  textDecoration: task.completed ? "line-through" : "none",
                  flex: 1,
                  marginLeft: "10px",
                  backgroundColor: task.completed ? "gray" : "",
                  borderRadius: task.completed ? "4px" : "",
                  paddingLeft: "10px",
                  whiteSpace: 'pre-line'
                }}
              >
                {task.titulo}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <IconButton
                  color="secondary"
                  onClick={() => {
                    setEditingTask(task);
                    setTaskTitle(task.titulo);
                    setOpenDialog(true);
                  }}
                  title="Editar"
                  disabled={!(idjerarquia == 2 || [2, 3].includes(usuario[0]?.idrol))}
                >
                  <EditIcon />
                </IconButton>
                <IconButton
                  style={{ color: "#e57373" }}
                  title="Eliminar"
                  onClick={() => handleClickOpen(task.iditem)}
                  disabled={!(idjerarquia == 2 || [2, 3].includes(usuario[0]?.idrol))}
                >
                  <DeleteIcon />
                </IconButton>
              </div>
            </Grid>
          </>
        ))}
      </Grid>

      <Button
        variant="contained"
        color="#146C94"
        startIcon={<AddIcon />}
        onClick={handleOpenDialog}
        style={{ marginTop: "16px" }}
        size="small"
      >
        Añadir Tarea
      </Button>

      <Dialog open={openDialog} onClose={handleCloseDialog} PaperProps={{
          style: {
            width: "80%", // Ajustar ancho dinámicamente
          },
        }}>
        <DialogTitle>
          {editingTask ? "Editar Tarea" : "Añadir Nueva Tarea"}
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Título de la Tarea"
            value={taskTitle}
            onChange={(e) => setTaskTitle(e.target.value)}
            variant="outlined"
            className={classesTablero.field}
            multiline
            minRows={4}
          />
        </DialogContent>
        <DialogActions style={{ justifyContent: "flex-end" }}>
          <Button
            onClick={handleCloseDialog}
            className={classesTablero.btnCancelar}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleAddOrEditTask}
            className={classesTablero.btnAceptar}
          >
            {editingTask ? "Guardar Cambios" : "Añadir"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDialogDelete}
        onClose={handleCloseDeleteDialog}
        fullWidth={true}
        maxWidth={"sm"}
      >
        <DialogTitle>
          ¡ADVERTENCIA!{" "}
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={handleCloseDeleteDialog}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText style={{ color: "white" }}>
            La tarea se eliminará permanentemente, ¿desea continuar?
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "flex-end" }}>
          <Button onClick={handleCloseDeleteDialog} color="secondary">
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmDeleteTareas}
            className={classesTablero.btnEliminar}
          >
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CheckListProgressBar;
